module.exports = __webpack_public_path__ + "img/handmade-chevron-right.8be7c119.svg";